export default "__VITE_ASSET__905bf7a3__"